import {
  // GET_ERRORS,
  // REQUEST_CHILDREN_DATA,
  SUCCESS_CHILDREN_DATA,
  GET_SELECT_CHILDREN,
  SELECT_CHILDREN,
  SUCCESS_CHILDREN_BY_APP_ID
} from '../actions/types';

const initialState = {
  data: [],
  selectChildrenArr: [],
  childrenSelected: [],
  childrenByAppID: []
};

export default function getChildrenData(state = initialState, action) {
  switch (action.type) {
    // case REQUEST_CHILDREN_DATA:
    //   return Object.assign({}, state, {
    //         isRequest: true,
    //         isError:false,
    //   })
    case SUCCESS_CHILDREN_DATA:
      return { ...state, data: action.payload };
    case 'TEST_ADD':
      return {
        ...state,
        data: [...state.data, action.payload]
      };
    case GET_SELECT_CHILDREN:
      return { ...state, selectChildrenArr: action.payload };
    case SELECT_CHILDREN:
      return { ...state, childrenSelected: [...action.payload] };
    case SUCCESS_CHILDREN_BY_APP_ID:
      return { ...state, childrenByAppID: action.payload };
    // case GET_ERRORS:
    //   return Object.assign({}, state, {
    //         isRequest: false,
    //         error:action.error,
    //         isError:true,
    //   })
    default:
      return state;
  }
}
